import { Pipe } from '@angular/core';

import type { PipeTransform } from '@angular/core';
import type { Duration } from '@kp/interfaces';

type DateObj =
  | {
      start?: string | undefined;
      end?: string | undefined;
    }
  | undefined;

@Pipe({ name: 'kpFormatDate' })
class FormatDatePipe implements PipeTransform {
  transform(value: DateObj | Duration | undefined, first: boolean): string {
    const start =
      (value as DateObj | undefined)?.start ||
      (value as Duration | undefined)?.beginDate;
    const end =
      (value as DateObj | undefined)?.end ||
      (value as Duration | undefined)?.endDate;

    if (!start) {
      return '';
    }

    if (start === end || !first) {
      return formatDate(start);
    }

    const differentYear = end
      ? !start.startsWith(end.slice(0, 4)) ||
        Number(start.slice(0, 4)) !== new Date().getFullYear()
      : false;

    return `${formatDate(start, differentYear)} – ${
      end ? formatDate(end) : ''
    }`;
  }
}

function formatDate(value: string, withYear = true): string {
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'numeric',
    ...(withYear ? { year: 'numeric' } : {}),
  };

  return new Intl.DateTimeFormat('cs-CZ', options).format(new Date(value));
}

export type { DateObj };
export { FormatDatePipe };
